export const fetchPieChartData = async (request, payload) => {
    try {
        const response = await request("POST", `/v1/survey/charts`,{ data: { "location": payload.location, "query":payload.query, "year": payload.year } }, "survey_service");
        return response;

    } catch (error) {
        console.log(error)
    }

};


export const pieChartData = {
    "total": 400,
    "data": [
        {
            "name": "Kacha/jhupri",
            "value": 10
        },
        {
            "name": "Pucca",
            "value": 193
        },
        {
            "name": "Semi-Pucca",
            "value": 121
        },
        {
            "name": "Tinshed",
            "value": 76
        },
        {
            "name":"Null",
            value:0
        }
    ]
}